import axios from "axios";

export default {
  namespaced: true,
  state: {
    vendors: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    vendorsMessage: ''
  },
  mutations: {
    RECEIVED_VENDORS(state, payload) {
      state.vendors = payload;
      state.isReceiving = false;
    },
    RECEIVING_VENDORS(state) {
      state.isReceiving = true;
    },
    RECEIVED_VENDOR(state, payload) {
      state = Object.assign(state, {
        vendors: [...state.vendors, payload],
        isReceiving: false,
      })
    },
    RECEIVING_VENDOR(state) {
      state.isReceiving = true;
    },
    UPDATED_VENDOR(state, payload) {
      let index = state.vendors.findIndex(vendor => vendor._id === payload._id);
      state = Object.assign(state, {
        vendors: state.vendors.map((vendor, i) => {
          if (i === index) {
            return Object.assign({}, vendor, payload);
          }
          return vendor;
        }),
        isUpdating: false,
        vendorsMessage: 'Vendors has been updating!',
      })
    },
    UPDATING_VENDOR(state) {
      state.isUpdating = true;
    },
    DELETED_VENDOR(state, payload) {
      let indexToDelete = state.vendors.findIndex(vendor => vendor._id === payload._id);
      let vendors = [...state.vendors];
      vendors.splice(indexToDelete, 1);
      state = Object.assign(state, {
        vendors: [...vendors],
        isDeleting: false,
        idToDelete: null,
        vendorsMessage: 'Vendor has been Deleted!',
      });
    },
    DELETING_VENDOR(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async insertVendorWithImageRequest({dispatch}, payload) {
      dispatch("receivingVendors");
      var token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/vendor/withimage';
      let data = new FormData();
      data.append('image', payload.vendorimage, payload.imagename); 
      delete payload['vendorimage'];
      for (let x in payload) data.append(x, payload[x]);
      let headers = { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + token};
      var post = {method: "post", url: url, headers: headers, data: data};
      return axios(post)
      .then(function (response) {
        dispatch("receiveVendor", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    async insertVendorRequest({dispatch}, payload) {
      dispatch("receivingVendors");
      var token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/vendor';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let  post = {method: "post", url: url, headers: headers, data: data};
      return axios(post)
      .then(function (res) {
        dispatch("receiveVendor", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    deleteVendorRequest({dispatch}, payload) {
      dispatch("deletingVendor", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/delete/vendor/' + payload._id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: 'delete', headers: headers, url: url}).then(() => {
        dispatch("deleteVendor", {_id: payload._id});
      })
    },
    async getVendorsRequest({dispatch}) {
      dispatch("receivingVendors");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/vendors';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        console.log(response.data)
        dispatch("receiveVendors", response.data);
      })
    },
    updateVendorRequest({dispatch}, payload) {
      dispatch("updatingVendor");
      var id = payload._id;
      delete payload['_id'];

      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/update/vendor/' + id;
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var put = {
        method: "put",
        url: url,
        headers: header,
        data: payload,
      };

      axios(put)
      .then(function (res) {
        dispatch("updateVendor", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    updateVendorOptionsRequest({dispatch}, payload) {
      dispatch("updatingVendor");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/vendor/options/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "put", url: url, headers: headers, data: payload})
      .then(function (res) {
        dispatch("updateVendor", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    updateVendorImageRequest({dispatch}, payload) {
      dispatch("updatingVendor");
      var data;
      var header;
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];

      var url = 'https://api.tradexc.com:3000/update/vendor/image/' + id;
      data = new FormData();
      data.append('image', payload.vendorimage, payload.imagename); 
      delete payload['vendorimage'];
      for (let x in payload) {
        data.append(x, payload[x]);
      }
      header = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
      };

      var put = {
        method: "put",
        url: url,
        headers: header,
        data: data,
      };

      axios(put)
      .then(function (res) {
        dispatch("updateVendor", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    receiveVendors({commit}, payload) {
      commit("RECEIVED_VENDORS", payload)
    },
    receivingVendors({commit}) {
      commit("RECEIVING_VENDORS")
    },
    receiveVendor({commit}, payload) {
      commit("RECEIVED_VENDOR", payload)
    },
    receivingVendor({commit}) {
      commit("RECEIVING_VENDOR")
    },
    updateVendor({commit}, payload) {
      commit("UPDATED_VENDOR", payload)
    },
    updatingVendor({commit}) {
      commit("UPDATING_VENDOR")
    },
    deleteVendor({commit}, payload) {
      commit("DELETED_VENDOR", payload)
    },
    deletingVendor({commit}, payload) {
      commit("DELETING_VENDOR", payload)
    }
  },
};
